import type { RoomSnapshot } from "@tuit/shared-types";

export interface PinnedItem {
  id: string;
  title: string;
  url: string;
}

function get<T>(key: string, parse: (raw: string) => T): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw !== null ? parse(raw) : null;
  } catch {
    return null;
  }
}

function set(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {}
}

export const userConfigurationStorage = {
  themeName: {
    get: (): string | null => get("themeName", (v) => v),
    set: (name: string) => set("themeName", name),
  },
  colorMode: {
    get: (): "light" | "auto" | "dark" | null =>
      get("colorMode", (v) =>
        v === "light" || v === "auto" || v === "dark" ? v : null,
      ),
    set: (mode: "light" | "auto" | "dark") => set("colorMode", mode),
  },
  readIds: {
    get: (): string[] => get("tuit-read-ids", (v) => JSON.parse(v) as string[]) ?? [],
    set: (ids: string[]) => set("tuit-read-ids", JSON.stringify(ids)),
  },
  pinned: {
    get: (): PinnedItem[] => get("tuit-pinned", (v) => JSON.parse(v) as PinnedItem[]) ?? [],
    set: (items: PinnedItem[]) => set("tuit-pinned", JSON.stringify(items)),
  },
  snapshotCache: {
    get: (groupId: string): RoomSnapshot | null =>
      get(`tuit-snapshot-cache:${groupId}`, (v) => JSON.parse(v) as RoomSnapshot),
    set: (groupId: string, snapshot: RoomSnapshot) =>
      set(`tuit-snapshot-cache:${groupId}`, JSON.stringify(snapshot)),
  },
  roomOrder: {
    get: (roomId: string): string[] | null =>
      get(`tuit-order-${roomId}`, (v) => JSON.parse(v) as string[]),
    set: (roomId: string, order: string[]) =>
      set(`tuit-order-${roomId}`, JSON.stringify(order)),
  },
  postFontSize: {
    get: (): string | null => get("tuit-post-font-size", (v) => v),
    set: (v: string) => set("tuit-post-font-size", v),
  },
  postFontWeight: {
    get: (): string | null => get("tuit-post-font-weight", (v) => v),
    set: (v: string) => set("tuit-post-font-weight", v),
  },
};
